import { Box, Typography } from "@material-ui/core";
import WarningRounded from "@mui/icons-material/WarningRounded";
import React from "react";
import { isObjectNotEmpty } from "../../Utils";

export default function ErrorMsg({ message, style = {} }) {
    if (isObjectNotEmpty(message)) {
        return (
            <Box name="errorMsg" display="flex" style={style} mt={3}>
                <Box>
                    <WarningRounded color="error" />
                </Box>
                <Box p={1}>
                    <Typography component={"span"} color="error">
                        {message}
                    </Typography>
                </Box>
            </Box>
        );
    } else {
        return <></>;
    }
}
